import { LevelType } from 'data/types';
import { hasFootprintPolygons } from 'utils/footprint-polygons';
import { getFirstMainLevelIndex } from 'utils/footprint-auto-scale';

export function getFootprintStepLevelIndices(structure: LevelType[]): number[] {
  const total = structure.length;
  if (total === 0) {
    return [];
  }
  const start = getFirstMainLevelIndex(structure);
  return Array.from({ length: total }, (_, i) => (start + i) % total);
}

export function getFootprintStepSubStepIndex(
  structure: LevelType[],
  selectedLevelIndex: number
): number {
  const ordered = getFootprintStepLevelIndices(structure);
  if (ordered.length === 0) {
    return 0;
  }
  const pos = ordered.indexOf(selectedLevelIndex);
  if (pos === -1) {
    return 0;
  }
  return pos;
}

export function isFootprintLevelComplete(
  level: LevelType | undefined
): boolean {
  if (!level) {
    return false;
  }
  return hasFootprintPolygons(level);
}
